import styled, { css } from "styled-components";

export const CommonCheckbox = styled.input<{
  disable?: boolean;
  indeterminate?: boolean;
}>`
  position: relative;
  cursor: ${({ disable }) => (disable ? "not-allowed" : "pointer")};
  width: 16px;
  height: 16px;
  opacity: 0;
  + .border-box {
    position: absolute;
    left: 0;
    top: 50%;
    width: 16px;
    height: 16px;
    pointer-events: none;
    transform: translate(0, -50%);
    cursor: pointer;
    span {
      position: relative;
      display: flex;
      width: 16px;
      height: 16px;
      &::before {
        visibility: visible;
        position: absolute;
        content: "";
        width: 16px;
        height: 16px;
        border: 1px solid #666;
        border-radius: 3px;
        box-sizing: border-box;
      }
      &::after {
        visibility: visible;
        content: "";
        position: absolute;
        top: 48%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(45deg);
        width: 5px;
        height: 8px;
        border: solid transparent;
        border-width: 0 2px 2px 0;
        box-sizing: border-box;
      }
    }
  }
  &:checked {
    + .border-box {
      span {
        &::before,
        &::after {
          border-color: var(--main-color);
        }
      }
    }
  }
  &[disabled] {
    + .border-box {
      span {
        &::before,
        &::after {
          border-color: gray;
        }
      }
    }
  }
`;

export const ContainedCheckbox = styled(CommonCheckbox)`
  + .border-box span {
    &::before {
      border-radius: 2px;
      border: 1px solid #646c77;
    }
    &::after {
      width: 7px;
      height: 10px;
      top: 45%;
      border-width: 0 3px 3px 0;
    }
  }
  &:checked {
    + .border-box span {
      &::before {
        border: none;
        background: var(--main-color);
      }
      &::after {
        border-color: #fff;
      }
    }
  }
  ${(p) =>
    p.indeterminate &&
    css`
      + .border-box span {
        &::before {
          border: none;
          background: var(--main-color);
        }
        &::after {
          border-color: #fff;
          width: 8px;
          height: 2px;
          transform: unset;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    `}
`;

export const CheckboxWrapper = styled.div<{
  gap?: number;
  disabled?: boolean;
  hidden?: boolean;
}>`
  position: relative;
  display: flex;
  align-items: center;
  width: fit-content;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  > *:first-child {
    margin-right: ${(p) => `${p.gap}px`};
  }
  &:hover {
    .border-box {
      span {
        &::before {
          border-color: var(--main-color);
        }
      }
    }
  }
  ${(p) =>
    p.hidden &&
    css`
      opacity: 0;
      pointer-events: none;
    `}
`;
